import * as yup from "yup";
import { maxLengthMessage } from "../../utils/functions";

export const getCodeColumns = (title) => {
  const columns = [
    { field: "code", headerName: "Code" },
    { field: "description", headerName: "Description", width: 225 },
  ];

  if (title === "Employment Status") {
    columns.push({
      field: "activeEmployee",
      headerName: "Active Employee",
      type: "boolean",
    });
  }

  if (title === "Rank") {
    columns.push({
      field: "rankOrder",
      headerName: "Rank Order",
    });
  }

  columns.push(
    { field: "category", headerName: "Category" },
    { field: "isDefault", headerName: "Default", type: "boolean" },
    { field: "isDeleted", headerName: "Deleted", type: "boolean" },
    { field: "isActive", headerName: "Active", type: "boolean" },
    { field: "flags", headerName: "Flags" },
    { field: "code2", headerName: "Code 2" },
    { field: "description2", headerName: "Description 2" },
    { field: "code3", headerName: "Code 3" },
    { field: "description3", headerName: "Description 3" },
    { field: "code4", headerName: "Code 4" },
    { field: "description4", headerName: "Description 4" }
  );

  return columns;
};

export const getCodeInitialFormValues = (title) => {
  let base = {
    code: "",
    description: "",
    category: "",
    flags: "",
    code2: "",
    description2: "",
    code3: "",
    description3: "",
    code4: "",
    description4: "",
  };

  if (title === "Employment Status") {
    base = {
      ...base,
      activeEmployee: false,
      isDefault: false,
      isActive: true,
    };
  } else if (title === "Rank") {
    base = {
      ...base,
      rankOrder: 0,
      isDefault: false,
      isActive: true,
    };
  } else {
    base = {
      ...base,
      isDefault: false,
      isActive: true,
    };
  }

  return base;
};

export const codeFieldMetadata = {
  code: { label: "Code" },
  description: { label: "Description" },
  activeEmployee: { label: "Active Employee" },
  category: { label: "Category" },
  flags: { label: "Flags" },
  code2: { label: "Code 2" },
  description2: { label: "Description 2" },
  code3: { label: "Code 3" },
  description3: { label: "Description 3" },
  code4: { label: "Code 4" },
  description4: { label: "Description 4" },
  isDefault: { label: "Default" },
  isActive: { label: "Active" },
  rankOrder: { label: "Rank Order" },
};

export const codeSchema = yup.object().shape({
  code: yup
    .string()
    .trim()
    .required("Code is required")
    .max(10, maxLengthMessage(10)),
  description: yup
    .string()
    .trim()
    .required("Description is required")
    .max(100, maxLengthMessage(100)),
  activeEmployee: yup.boolean().nullable(),
  rankOrder: yup
    .number()
    .typeError("Rank order must be a number")
    .min(0, "Rank order must be 0 or greater")
    .nullable(),
  category: yup.string().trim().max(10, maxLengthMessage(10)).nullable(),
  flags: yup.string().trim().max(10, maxLengthMessage(10)).nullable(),
  code2: yup.string().trim().max(10, maxLengthMessage(10)).nullable(),
  description2: yup.string().trim().max(100, maxLengthMessage(100)).nullable(),
  code3: yup.string().trim().max(10, maxLengthMessage(10)).nullable(),
  description3: yup.string().trim().max(100, maxLengthMessage(100)).nullable(),
  code4: yup.string().trim().max(10, maxLengthMessage(10)).nullable(),
  description4: yup.string().trim().max(100, maxLengthMessage(100)).nullable(),
  isDefault: yup.boolean().nullable(),
  isActive: yup.boolean().nullable(),
});
